import PostsService from '../../../services/posts.service'
import ProjectsService from '../../../services/projects.service'
import { Notification } from 'element-ui';
import $router from '../../../router';

export default {
  getListPublic ({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return PostsService.fetchProjects(payload.params)
      .then(response => {
        commit('SET_ITEMS', response.data.content.data)
        //commit('SET_PAGINATION', { total: response.length })
        commit('SET_LOADING', false)
      })
      .catch(error => commit('SET_ERROR', error.message))
      .finally(() => commit('SET_LOADING', false))
  },
  updateProject ({ state, commit }, payload) {
    commit('SET_LOADING', true);    
    return ProjectsService.updateProject(payload)
    .then(response => {
      Notification.success({
        title: 'Project "' + payload.data.name  + '" updated',
        message: 'saved to scheduler'
      });
      commit('SET_LOADING', false);
      commit('PROJECT_UPDATED', true);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Project "' + payload.data.name  + '" was not saved',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false))
  },
  createProject ({ state, commit }, payload) {
    commit('SET_LOADING', true);    
    return ProjectsService.createProject(payload)
    .then(response => {
      $router.push({ name: 'project', params: { id: response.data.id } });
      /*Notification.success({
        title: 'Project "' + payload.data.name  + '" updated',
        message: 'saved to scheduler'
      });*/
      commit('SET_LOADING', false)
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      /*Notification.error({
        title: 'Project "' + payload.data.name  + '" was not saved',
        message: error.message,
        duration: 0
      });*/
    })
    .finally(() => commit('SET_LOADING', false))
  }
}
